import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import logo from "../../Assets/NewList/shop-logo.png";
import Logo2 from "../../Assets/main-logo.png";
import { passwordModalChecked } from "../../Store/Slices/clientConfigDataSlice";
import { useDispatch } from "react-redux";

const PasswordProtectedModal = ({ show, handleClose, isprotectedDescription }) => {
    const [password, setPassword] = useState("");
    const [isInvalid, setIsInvalid] = useState(false);
    const dispatch = useDispatch();
    const handleChange = (e) => {
        setPassword(e.target.value);
        if (isInvalid) {
            setIsInvalid(false);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === "") {

            setIsInvalid(true);
            return;
        }
        if (!password.trim()) {
            setIsInvalid(false);
            return;
        }

        if (isprotectedDescription === password.trim()) {
            dispatch(passwordModalChecked());
            handleClose();
        } else {
            setIsInvalid(true);
        }
    };
    return (
        <div className="modal_Quick">
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="exampleModalLabel"
                centered
                className={`earn-points-modal widget-card`}
                backdrop="static"
                keyboard={false}
            >
                {/* <ToastContainer /> */}
                <Modal.Body style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
                    <div
                        id="WidgetCardSelectModel"
                        className="position-relative-QuickModal"
                    >
                        {/* Fixed Header */}
                        <div className="my-3">

                            <div className="mb-5-px text-center">

                                <img src={Logo2} alt="Protected" width={100} />

                            </div>

                        </div>
                        <Form.Group controlId="formPassword" className="mb-3">
                            <Form.Control
                                type="password"
                                placeholder="Enter password"
                                value={password}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        {isInvalid && <span style={{ color: "red" }}>Invalid Password. Please try again.</span>}
                        <Button className="btn-primary mb-3 mt-3 custom-button" style={{ height: 'auto' }} onClick={handleSubmit}>
                            Submit
                        </Button>

                    </div>
                </Modal.Body>
            </Modal>
        </div >
    );
}
export default PasswordProtectedModal;